// Generated by tools/gen-backend-hooks.ts — do not edit by hand.
// One hook per endpoint in backend/tierReview/.

import { makeBackendHook } from './_client'

export type { BackendQuery, TriggerOptions } from './_client'

/** POST /api/rpc/tierReview/decideTierReviewItem */
export const useDecideTierReviewItem = makeBackendHook('tierReview', 'decideTierReviewItem')

/** POST /api/rpc/tierReview/getTierReview */
export const useGetTierReview = makeBackendHook('tierReview', 'getTierReview')

/** POST /api/rpc/tierReview/getTierReviewSettings */
export const useGetTierReviewSettings = makeBackendHook('tierReview', 'getTierReviewSettings')

/** POST /api/rpc/tierReview/getTierReviewStatus */
export const useGetTierReviewStatus = makeBackendHook('tierReview', 'getTierReviewStatus')

/** POST /api/rpc/tierReview/runTierReview */
export const useRunTierReview = makeBackendHook('tierReview', 'runTierReview')

/** POST /api/rpc/tierReview/updateTierReviewSettings */
export const useUpdateTierReviewSettings = makeBackendHook('tierReview', 'updateTierReviewSettings')
